module.exports = __webpack_public_path__ + "img/N351-1-EN.c7f161af.png";